<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content>
  <div class="bulletin-component" *ngIf='bulletin != null'>
    <mat-card>
      <mat-card-title style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
        <div style="flex:0 0 96px" class="logo">
          <img height="47" src="../../../assets/img/RiskSponge%20Logo%20shield-orange.png"/>
        </div>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; flex:1 1 auto">{{bulletin.name}}</h2>
        <time style="display: flex; flex-direction: row; flex:0 0 auto">
          <div class="title">Issue date: </div>
          <div>{{bulletin.date | date:'MMMM d, yyyy'}}</div></time>
      </mat-card-title>
      <mat-card-content>
        <div style="display: flex; flex-direction: row;">
          <div style="flex:1 1 auto">
            <div class="row" style="margin-top: 20px;">
              <div class="title">Analysis & Recommendation:</div>
              <div style="flex:100%; white-space: pre-line;">{{bulletin.analysis.trim()}}</div>
            </div>

            <div class="row" style="margin-top: 38px;">
              <div class="title">Recommended Actions:</div>
              <div style="flex:100%; white-space: pre-line;">{{bulletin.recommendedActions.trim()}}</div>
            </div>

            <div class="row" style="margin-top: 29.5px;">
              <div class="title" style="margin-bottom: 20px;">Impacted Control and Compliance Areas:</div>
              <div style="flex:100%">{{bulletin.areaNames.join(', ')}}</div>
            </div>
          </div>
          <div style="flex:0 0 240px; justify-content: center; padding-top:28.5px;">
            <img height="190" src="../../../assets/img/Female%20Guide%20Pointing%20Left-black%20hair.png"/>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
